import type { FC } from "react"
import { useMemo } from "react"
import Fuse from "fuse.js"
import {
	IconCheckOutline18 as Check,
	IconUsersOutline18 as Users,
} from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps, WithQuery } from "./types"
import { useRoadmapFilterState } from "../roadmap-filter-state"
import { isTeamSelected } from "../roadmap-team-groups"
import { useRoadmapTeams } from "../use-roadmap-teams"

export const TeamFilterItems: FC<SharedFilterItemsProps & WithQuery> = ({
	onSelect,
	query,
}) => {
	const { teamIds, toggleTeam } = useRoadmapFilterState()
	const teams = useRoadmapTeams()

	const filteredTeams = useMemo(() => {
		if (!query) return teams
		const fuse = new Fuse(teams, { keys: ["name"], threshold: 0.4 })
		return fuse.search(query).map((r) => r.item)
	}, [teams, query])

	if (teams.length === 0) {
		return (
			<div className="py-4 text-center text-sm text-secondary">
				No teams available
			</div>
		)
	}

	return (
		<>
			{filteredTeams.map((team) => {
				const isSelected = isTeamSelected(team, teamIds)
				return (
					<CommandItem
						key={team.id}
						value={team.id}
						onSelect={() => {
							toggleTeam(team)
							onSelect()
						}}
					>
						<div className="flex w-full items-center gap-2">
							<Users className="h-4 w-4 shrink-0 text-secondary" />
							<span className="flex-1 truncate">{team.name}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
